<template>
  <van-config-provider :theme-vars="{ primaryColor: '#FDBB2B' }" theme-vars-scope="global">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" :key="route.path" />
      </keep-alive>
    </router-view>
  </van-config-provider>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<style scoped lang="scss"></style>
